export default __webpack_public_path__ + "static/media/icon-light.55280abb.svg";